const baseStyle = {
    color: "font.primary",
};
const variants = {
    h1: {
        as: "h1",
        fontSize: ["2.25rem", null, null, "3rem"],
        lineHeight: "short",
    },
    h2: {
        as: "h2",
        fontSize: ["1.875rem", null, null, "2.25rem"],
        lineHeight: "short",
    },
    h3: {
        as: "h3",
        fontSize: ["1.5rem", null, null, "1.875rem"],
        lineHeight: "short",
    },
    h4: {
        as: "h4",
        fontSize: ["1.375rem", null, null, "1.5rem"],
        lineHeight: "base",
    },
    h5: {
        as: "h5",
        fontSize: "1.25rem",
        lineHeight: "base",
    },
};
const defaultProps = {
    variant: "h1",
};
const Heading = {
    baseStyle,
    variants,
    defaultProps,
};
export default Heading;
